import { useSyncExternalStore } from 'react'

export type NavMode = 'sidebar' | 'rail' | 'drawer'

// Must equal the Sass breakpoints `desktop` and `tablet`
// (styles/abstracts/_breakpoints.scss); ADR 0012.
export const DESKTOP_QUERY = '(min-width: 1152px)'
export const TABLET_QUERY = '(min-width: 768px)'

// jsdom declares matchMedia but leaves it undefined.
const hasMatchMedia = () => typeof (window as Partial<Window>).matchMedia === 'function'

function read(): NavMode {
  // No matchMedia (jsdom): the desktop form.
  if (!hasMatchMedia()) return 'sidebar'
  if (window.matchMedia(DESKTOP_QUERY).matches) return 'sidebar'
  if (window.matchMedia(TABLET_QUERY).matches) return 'rail'
  return 'drawer'
}

function subscribe(onChange: () => void): () => void {
  if (!hasMatchMedia()) return () => undefined
  const lists = [DESKTOP_QUERY, TABLET_QUERY].map((query) => window.matchMedia(query))
  for (const list of lists) list.addEventListener('change', onChange)
  return () => {
    for (const list of lists) list.removeEventListener('change', onChange)
  }
}

/** The navigation form for the viewport width, or the forced one. */
export function useNavMode(forced: 'auto' | NavMode = 'auto'): NavMode {
  const auto = useSyncExternalStore(subscribe, read, () => 'sidebar' as const)
  return forced === 'auto' ? auto : forced
}
